import React from 'react';
import './AboutPage.css';

function AboutPage() {
  return (
    <div className="about-page">
      <div className="container">
        <div className="page-header">
          <h2>About NyotaFund</h2>
        </div>

        <div className="about-content">
          <div className="about-section">
            <h3>Our Mission</h3>
            <p>
              NyotaFund is dedicated to providing accessible and affordable loan solutions 
              to Kenyans. We believe in empowering individuals and small businesses with 
              the financial support they need to achieve their goals.
            </p>
          </div>

          <div className="about-section">
            <h3>What We Offer</h3>
            <ul>
              <li>Business Loans up to Ksh 230,000</li>
              <li>Personal Loans up to Ksh 50,000</li>
              <li>Emergency Loans up to Ksh 20,000</li>
              <li>Quick approval process</li>
              <li>Flexible repayment terms</li>
            </ul>
          </div>

          <div className="about-section">
            <h3>Why Choose NyotaFund?</h3>
            <div className="features-grid">
              <div className="feature">
                <div className="feature-icon">⚡</div>
                <h4>Fast Processing</h4>
                <p>Quick application and approval process</p>
              </div>
              <div className="feature">
                <div className="feature-icon">📱</div>
                <h4>Mobile Friendly</h4>
                <p>Accessible on all devices</p>
              </div>
              <div className="feature">
                <div className="feature-icon">🔒</div>
                <h4>Secure</h4>
                <p>Your data is safe with us</p>
              </div>
              <div className="feature">
                <div className="feature-icon">💰</div>
                <h4>Affordable</h4>
                <p>Competitive interest rates</p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h3>Contact Information</h3>
            <p>Email: info@nyotafund.co.ke</p>
            <p>Phone: +254 700 000 000</p>
            <p>Hours: Monday - Friday, 8:00 AM - 5:00 PM</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;